export const META_ACTION = 'send_meta_conversion';

export const isMetaAction = key => key === META_ACTION;

// Eventos padrão da API de Conversões da Meta, agrupados como no seletor do editor.
export const META_EVENT_SECTIONS = [
  {
    key: 'ENGAGEMENT',
    events: [
      { key: 'Lead', icon: 'i-lucide-user-plus' },
      { key: 'Contact', icon: 'i-lucide-message-circle' },
      { key: 'Schedule', icon: 'i-lucide-calendar' },
      { key: 'CompleteRegistration', icon: 'i-lucide-clipboard-check' },
      { key: 'SubmitApplication', icon: 'i-lucide-file-text' },
    ],
  },
  {
    key: 'SALES',
    events: [
      { key: 'Purchase', icon: 'i-lucide-shopping-bag' },
      { key: 'Subscribe', icon: 'i-lucide-repeat' },
      { key: 'StartTrial', icon: 'i-lucide-play' },
      { key: 'Donate', icon: 'i-lucide-heart-handshake' },
    ],
  },
  {
    key: 'ECOMMERCE',
    events: [
      { key: 'AddToCart', icon: 'i-lucide-shopping-cart' },
      { key: 'InitiateCheckout', icon: 'i-lucide-credit-card' },
      { key: 'AddPaymentInfo', icon: 'i-lucide-credit-card' },
      { key: 'AddToWishlist', icon: 'i-lucide-heart' },
      { key: 'ViewContent', icon: 'i-lucide-eye' },
      { key: 'Search', icon: 'i-lucide-search' },
      { key: 'CustomizeProduct', icon: 'i-lucide-sliders-horizontal' },
      { key: 'FindLocation', icon: 'i-lucide-map-pin' },
    ],
  },
];

export const META_EVENTS = META_EVENT_SECTIONS.flatMap(({ events }) => events);

export const META_ACTION_SOURCES = [
  'system_generated',
  'website',
  'chat',
  'email',
  'phone_call',
  'physical_store',
  'business_messaging',
  'app',
  'other',
];

// Mensagens comerciais exigem o canal e os identificadores dele (a Meta recusa o evento sem eles).
export const MESSAGING_SOURCE = 'business_messaging';
export const META_MESSAGING_CHANNELS = ['whatsapp', 'messenger', 'instagram'];
export const META_MESSAGING_FIELDS = {
  whatsapp: ['whatsapp_business_account_id', 'page_id'],
  messenger: ['page_id', 'page_scoped_user_id'],
  instagram: ['instagram_business_account_id', 'ig_sid'],
};

// Parâmetros que a Meta aceita; "param" é o nome enviado na API. Os marcados com
// "hashed" seguem para a Meta em SHA-256 (feito só no servidor, nunca no navegador).
const field = (key, param = key, hashed = false) => ({ key, param, hashed });

export const META_FIELD_SECTIONS = [
  {
    key: 'USER_DATA',
    fields: [
      field('email', 'em', true),
      field('phone', 'ph', true),
      field('first_name', 'fn', true),
      field('last_name', 'ln', true),
      field('city', 'ct', true),
      field('state', 'st', true),
      field('zip', 'zp', true),
      field('country', 'country', true),
      field('gender', 'ge', true),
      field('date_of_birth', 'db', true),
      field('external_id', 'external_id', true),
      field('fbc'),
      field('fbp'),
      field('lead_id'),
      field('ctwa_clid'),
      field('client_ip_address'),
      field('client_user_agent'),
    ],
  },
  {
    key: 'MESSAGING',
    fields: [
      field('whatsapp_business_account_id'),
      field('page_id'),
      field('page_scoped_user_id'),
      field('instagram_business_account_id'),
      field('ig_sid'),
    ],
  },
  {
    key: 'CUSTOM_DATA',
    fields: [field('value'), field('currency')],
  },
  {
    key: 'EVENT',
    fields: [field('event_id')],
  },
];

// Sem e-mail nem telefone a Meta quase não consegue correlacionar o evento.
export const META_IDENTITY_FIELDS = ['email', 'phone'];

export const newMetaData = () => ({
  meta_event: '',
  meta_fields: {},
  meta_action_source: 'system_generated',
  meta_messaging_channel: '',
});

// Um campo da Meta recebe um campo do Corvus ("contact|standard|email") ou um texto fixo ("fixed|BRL").
export const META_FIXED = 'fixed|';

export const isMetaFixed = value => !!value && value.startsWith(META_FIXED);

export const metaFixedText = value => value.slice(META_FIXED.length);

export const isMetaValueSet = value =>
  isMetaFixed(value) ? !!metaFixedText(value).trim() : !!value;

export const metaMappedCount = data =>
  Object.values(data.meta_fields || {}).filter(isMetaValueSet).length;

// Mesma regra de AutomationFlows::MetaMessaging no backend.
export const isMessagingIdentityComplete = data => {
  const mapped = key => isMetaValueSet(data.meta_fields?.[key]);
  switch (data.meta_messaging_channel) {
    case 'whatsapp':
      return (
        mapped('whatsapp_business_account_id') &&
        (mapped('ctwa_clid') ||
          (mapped('page_id') && META_IDENTITY_FIELDS.some(mapped)))
      );
    case 'messenger':
      return mapped('page_id') && mapped('page_scoped_user_id');
    case 'instagram':
      return mapped('instagram_business_account_id') && mapped('ig_sid');
    default:
      return false;
  }
};
